function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import React, { memo } from 'react';
import { Small } from '@finect/tabular-core/Small';
import { getFundBreakdowns, getBreakdownDefinition } from '@finect/front-resources/Products';
import { ParagraphSmall } from '@finect/tabular-core/Paragraph';
import { DateLabel } from '../../DateLabel';
import { Section } from '../../Section';
import { breakdownDefinitions } from '../../Products/ProductsTable/entities/breakdownDefinitions';
import { Tabs, TabsPane } from '../../Tabs';
import { TableList } from '../../Tables';
import { PercentLabel } from '../../Labels';
import { FundPortfolio } from './FundPortfolio';
import { breakdownsTypes } from './data';
import { compare } from './utils';
import { IconBlock, BarBlock, Bar, ValueColumn, Value, FooterDate } from './partials';
export var FundBreakdowns = function FundBreakdowns(_ref) {
  var fund = _ref.fund;
  var breakdownsTypesList = breakdownsTypes.map(function (breakdownsType) {
    var id = breakdownsType.id;
    var breakdowns = getFundBreakdowns(fund.breakdown, id);
    if (!breakdowns) return {
      max: null,
      items: []
    };
    breakdowns && breakdowns.items.sort(compare);
    var max = {
      short: Math.max.apply(Math, _toConsumableArray(breakdowns.items.map(function (_ref2) {
        var values = _ref2.values;
        return values.short;
      }))),
      long: Math.max.apply(Math, _toConsumableArray(breakdowns.items.map(function (_ref3) {
        var values = _ref3.values;
        return values.long;
      }))),
      net: Math.max.apply(Math, _toConsumableArray(breakdowns.items.map(function (_ref4) {
        var values = _ref4.values;
        return values.net;
      })))
    };
    return _objectSpread(_objectSpread({}, breakdowns), {}, {
      max: max,
      definition: breakdownsType,
      items: breakdowns.items.map(function (breakdown) {
        return _objectSpread(_objectSpread({}, breakdown), {}, {
          definition: getBreakdownDefinition(breakdownDefinitions, breakdown.id)
        });
      })
    });
  });
  var withPortfolio = fund.portfolio && fund.portfolio.date;
  var date = new Date(fund.portfolio.date);
  var portfolioTab = React.createElement(TabsPane, {
    key: "portfolio",
    title: "Portfolio"
  }, React.createElement(FundPortfolio, {
    fund: fund
  }));
  var tabs = [].concat(_toConsumableArray(breakdownsTypesList.filter(function (item) {
    return item.max;
  }).map(function (type, key) {
    if (!type.max) return React.createElement("div", {
      key: key
    }, "Sin datos");
    var _type$definition = type.definition,
      title = _type$definition.title,
      description = _type$definition.description;
    var rows = type.items.map(function (breakdown) {
      var definition = breakdown.definition,
        values = breakdown.values;
      var label = definition.label,
        Icon = definition.icon;
      return {
        params: {},
        cells: [{
          params: {
            type: 'CellWithIcon'
          },
          component: React.createElement("span", null, React.createElement(IconBlock, null, Icon ? React.createElement(Icon, null) : null), label)
        }, {
          params: {},
          component: React.createElement(Value, null, React.createElement(ValueColumn, null, React.createElement(PercentLabel, {
            value: values.net,
            decimals: 1
          })), React.createElement(BarBlock, null, React.createElement(Bar, {
            value: 100 * values.net / type.max.net
          })))
        }]
      };
    });
    return React.createElement(TabsPane, {
      key: key,
      title: title
    }, React.createElement(ParagraphSmall, null, description), React.createElement(TableList, {
      rows: rows
    }));
  })), _toConsumableArray(withPortfolio ? [portfolioTab] : []));
  if (!tabs.length) return null;
  return React.createElement(Section, {
    title: "Exposici\xF3n",
    bottomMargin: true
  }, React.createElement(Tabs, null, tabs), withPortfolio ? React.createElement(FooterDate, null, React.createElement(Small, {
    light: true
  }, "Datos a ", React.createElement(DateLabel, {
    date: date
  }))) : null);
};
export default memo(FundBreakdowns);